export default {
  // グラフデータ(type=plant)の追加用
  setGraphDialogFlag (state: {[key: string]: any}, flag: boolean) {
    state.graphDialogFlag = flag
  },
  // アグリノート画像表示用
  setAgrinoteImgFlag (state: {[key: string]: any}, flag: boolean) {
    state.agrinoteImgFlag = flag
  },
  // アグリノートメイン画像表示用
  setAgrinoteMainImgFlag (state: {[key: string]: any}, flag: boolean) {
    state.agrinoteMainImgFlag = flag
  },
  // 右側生育状況用
  setSensorDataFlag (state: {[key: string]: any}, flag: boolean) {
    state.sensorDataFlag = flag
  },
  // fieldでの絞り込みセレクトボックス作成用
  setSelectDataListFlag (state: {[key: string]: any}, flag: boolean) {
    state.selectDataListFlag = flag
  },
  // 一覧の詳細データ用
  setFieldDetailsDataFlag (state: {[key: string]: any}, flag: boolean) {
    state.fieldDetailsDataFlag = flag
  },
  // 一覧の詳細データモーダル用
  setModalFieldDetailsDataFlag (state: {[key: string]: any}, flag: boolean) {
    state.modalFieldDetailsDataFlag = flag
  },
  // グラフマスターデータ用
  setGraphMasterDataFlag (state: {[key: string]: any}, flag: boolean) {
    state.graphMasterDataFlag = flag
  },
  setPlantingIdFlag (state: {[key: string]: any}, flag: boolean) {
    state.setPlantingIdFlag = flag
  },
  setGraphChangeDisplayYear (state: {[key: string]: any}, flag: boolean) {
    state.graphChangeDisplayYear = flag
  },
  setGrowthDialogFlag (state: {[key: string]: any}, flag: boolean) {
    state.growthDialogFlag = flag
  },
  setComparisonPlantFlag (state: {[key: string]: any}, flag: boolean) {
    state.comparisonPlantFlag = flag
  },
  setComparisonMasterFlag (state: {[key: string]: any}, flag: boolean) {
    state.comparisonMasterFlag = flag
  }
}
